import { SetRightIcon } from './SetRightIcon';

/**
 * author: Simran
 * id 27D4B799-E231-49DF-AB06-0201493C83E9
 * name set-right
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/set-right.svg
 * tags
 * - Database 
 */
export const DifferenceRightIcon = SetRightIcon;
export default DifferenceRightIcon